/* eslint-disable arrow-body-style */
import React, { FC } from 'react';
import { ResultsChart } from './ResultsChart';
import { ResultsTable } from './tableComponents/ResultsTable';

interface Props {
  id: string;
}

export const Results: FC<Props> = ({ id }) => {
  const attrId = `${id}Results`;
  return (
    <div data-testid={attrId} data-cy={attrId}>
      <ResultsChart />
      <ResultsTable />
    </div>
  );
};
